import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, A11y } from 'swiper'
SwiperCore.use([Pagination, A11y])
import { createResource, useResource } from '@/lib/i18n'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'
import Link from 'next/link'

const resource = createResource({
  en: {
    title: 'Honours',
  },
  id: {
    title: 'Penghargaan',
  },
})

const Honours = () => {
  const { t } = useResource(resource)
  const FeatureList = [
    {
      img: '/images/home/honours/honours1.jpg',
      url: 'https://theponsel.com/news/kredit-pintar-raih-top-brand-award-2021/',
    },
    {
      img: '/images/home/honours/honours2.jpg',
      url: 'https://keuangan.kontan.co.id/news/kredit-pintar-raih-gelar-fintech-dana-tunai-terbaik-di-ajang-duniafintech-award-2022',
    },
    {
      img: '/images/home/honours/honours3.jpg',
      url: 'https://money.kompas.com/read/2022/04/14/132647326/direktur-kredit-pintar-ungkap-pentingnya-inovasi-untuk-keberlangsungan?page=all',
    },
    {
      img: '/images/home/honours/honours4.jpg',
      url: 'https://wartaekonomi.co.id/read237845/kredit-pintar-raih-penghargaan-di-asia-pacific-stevie-awards-2019',
    },
    {
      img: '/images/home/honours/honours5.jpg',
      url: 'https://www.industry.co.id/read/54749/kredit-pintar-meraih-penghargaan-reliable-financial-technology',
    },
    {
      img: '/images/home/honours/honours6.jpg',
      url: 'https://www.suaramerdeka.com/ekonomi/pr-04125579/kredit-pintar-sabet-penghargaan-startup-pinjaman-dana-tunai-terbaik',
    },
    {
      img: '/images/home/honours/honours7.jpg',
      url: 'https://wartaekonomi.co.id/read434855/103-perusahaan-dengan-digital-marketing-terbaik-kantongi-penghargaan-igdma-2022-oleh-warta-ekonomi',
    },
  ]
  const FeatureListByNoLink = [
    {
      img: '/images/home/honours/honours8.jpg',
      url: null,
    },
    {
      img: '/images/home/honours/honours9.jpg',
      url: null,
    },
    {
      img: '/images/home/honours/honours10.jpg',
      url: null,
    },
    {
      img: '/images/home/honours/honours11.jpg',
      url: null,
    },
    {
      img: '/images/home/honours/honours12.jpg',
      url: null,
    },
  ]
  return (
    <HonoursStyle>
      <h2 className="title">{t('title')}</h2>
      <div className="items">
        <Swiper
          className="myswiper"
          spaceBetween={10}
          slidesPerView={1}
          pagination={{ clickable: true }}
          breakpoints={{
            '@0.00': {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            '@1.00': {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            '@1.20': {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            '@1.50': {
              slidesPerView: 4,
              spaceBetween: 0,
            },
          }}
        >
          {FeatureList.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="item">
                <Link href={item.url}>
                  <a target="_blank" rel="nofollow">
                    <LazyLoad>
                      <div className="img">
                        <Image
                          src={item.img}
                          alt="honours"
                          width={285}
                          height={280}
                          quality={90}
                          priority
                          placeholder="empty"
                        />
                      </div>
                    </LazyLoad>
                  </a>
                </Link>
              </div>
            </SwiperSlide>
          ))}
          {FeatureListByNoLink.map((item, index) => (
            <SwiperSlide key={FeatureList.length + index + 1}>
              <div className="item">
                <a target="_blank" rel="nofollow">
                  <LazyLoad>
                    <div className="img">
                      <Image
                        src={item.img}
                        alt="honours"
                        width={285}
                        height={280}
                        quality={90}
                        priority
                        placeholder="empty"
                      />
                    </div>
                  </LazyLoad>
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </HonoursStyle>
  )
}

export default Honours

const HonoursStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 64px auto 0;
    text-align: center;
    max-width: 1440px;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      margin-bottom: 32px;
    }
    .items {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      .item {
        width: 360px;
        display: flex;
        justify-content: center;
        margin: 0 auto 32px;
        overflow: hidden;
        .img {
          width: 285px;
          height: 280px;
        }
        .item-img {
          width: 285px;
          height: 280px;
          display: block;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 104px 150px 0px;
    text-align: center;
    max-width: 1440px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      margin-bottom: 48px;
    }
    .items {
      display: flex;
      justify-content: center;
      .item {
        margin-bottom: 48px;
        width: 285px;
        height: 280px;
        .img {
          width: 285px;
          height: 280px;
        }
      }
    }
  }
`
